import React, { useState } from 'react'
import { LogoutFunction } from '../app-header/app-header'

export interface UserType {
  accessToken?: string
  photo?: string
  userDisplayName?: string | null
  userEmail?: string | null
  userPhoto?: string | null
  userInitials?: string | null
  userJobTitle?: string | null
  userOfficeLocation?: string | null
  userId?: string
}
interface UserContextInterface extends UserType {
  logOut?: LogoutFunction
  setUserData: React.Dispatch<React.SetStateAction<UserType>>
}
interface UserMiddlewareProps {
  children: React.ReactNode
  logout?: LogoutFunction
}

export const UserContext = React.createContext({} as UserContextInterface)

export const UserMiddleware: React.FC<UserMiddlewareProps> = ({ children }) => {
  const [userData, setUserData] = useState<UserType>({})

  return (
    <UserContext.Provider value={{ ...userData, setUserData }}>
      {children}
    </UserContext.Provider>
  )
}
